import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
    text: {
        '&&': {
            fontFamily: `'Rubik', sans-serif`,
            textAlign: 'center'
        }
    }
});